import { SxProps, Theme } from "@mui/material/styles";

export const styles: Record<string, SxProps<Theme>> = {
  newAccountContainer: {
    border: "1px solid",
    borderColor: "grey400",
    borderRadius: 1,
    p: 2,
    mb: 2,
  },
};
